import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-student-popup',
	standalone: true,
	imports: [],
	templateUrl: './student-popup.component.html',
	styleUrl: './student-popup.component.scss'
})
export class StudentPopupComponent {

	//constructor(private dialogRef: MatDialogRef<StudentPopupComponent>) { }

	// close() {
	// 	this.dialogRef.close();
	// }
}